import { Map, Set } from 'immutable';
import { appDb } from 'nike-re-framejs';

import { makeBoxesRequestParam, makeMatchesRequestParam, makeOnTicketsRequestParam } from './domain/filter';
import { makeMenuRequestParam } from './domain/filter';
import { normalizeSportEventId } from './domain/sportevent';
import n1Client from '@/_http/axiosN1Client';

export function loadSimpleSportEvents(sportEventIds) {
    const sportEventId = sportEventIds.map(normalizeSportEventId);
    return n1Client.get('/v1/boxes/sport-events', { params: { sportEventId } });
}

export function loadDetailBySportEventId(sportEventId) {
    return loadSimpleSportEvents([sportEventId]).then(json => {
        const sportEvent = (json.sportEvents || [])[0];
        if (!sportEvent || sportEvent.isLive) {
            return Promise.resolve(json);
        }
        return n1Client.get('/v1/boxes/extended/sport-event-id', { params: { sportEventId } });
    });
}

export function fetchBannersByBetNumbers(betIds) {
    if (!betIds || !betIds.length) {
        return Promise.resolve([]);
    }
    return n1Client.get('/v1/bets', { params: { betIds } });
}

export function loadBoxes(db, boxStore, boxIds, ns = []) {
    const filterData = db.getIn(ns.concat(['boxStore', boxStore, 'filter']));
    const request = makeBoxesRequestParam(Set(boxIds), filterData);
    return n1Client.get('/v1/boxes/search/mobile', { params: request });
}

export function loadMatches(matchIds) {
    const request = makeMatchesRequestParam(Set(matchIds));
    return n1Client.get('/v1/boxes/sport-events', { params: request });
}

export function loadCmsData(tournamentId, betId) {
    if (tournamentId && tournamentId.length) {
        return n1Client.get('/v1/boxes/tournaments', {
            params: {
                live: true,
                prematch: true,
                results: false,
                tournamentId
            }
        });
    }
    return n1Client.get(`/v1/boxes/bet-id/${betId}`);
}

export function loadOpenBoxes(db, boxStore) {
    const expandedBoxIds = db.getIn(['nikeone', 'boxStore', boxStore, 'filter', 'boxIds'], Map()).filter(Boolean);
    if (expandedBoxIds.isEmpty()) {
        return Promise.resolve({});
    }
    const filterData = db.getIn(['nikeone', 'boxStore', boxStore, 'filter']);
    const request = makeBoxesRequestParam(Set(expandedBoxIds.keySeq()), filterData);
    return n1Client.get('/v1/boxes/search/mobile', { params: request });
}

export function loadMenu(db, boxStore) {
    const request = makeMenuRequestParam(db, boxStore);
    return n1Client.get('/v1/menu', { params: request }).then(response => {
        response.request = request;
        return response;
    });
}

export function loadBettingDays() {
    return n1Client.get('/v1/init-data/mobile');
}

export function loadBoxByBetIds(betIds) {
    return n1Client.get('/v2/bets/analyses', { params: { betIds: betIds.join(',') } });
}

export function loadMatchesOnTicket(db, boxStore) {
    const filterData = db.getIn(['nikeone', 'boxStore', boxStore, 'filter']);
    const sportEventIds = appDb.peekValue().getIn(['ticketus', 'active', 'sportEventIds'], Set());
    if (sportEventIds.count() && filterData) {
        const request = makeOnTicketsRequestParam(filterData, Set(sportEventIds));
        return n1Client.get('/v1/boxes/matches-on-ticket', { params: request });
    } else {
        return Promise.resolve({});
    }
}
